/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Vo as Vo,
} from "../../runtime/index.jsx";
export function Componente_ck_99_107(e) {
  let t = (0, ReactCompiler.c)(14),
    { items: n, actual: r, onCambiar: i } = e,
    a;
  t[0] !== r || t[1] !== n || t[2] !== i
    ? ((a = function (e) {
        let t = n.findIndex((e) => e.id === r);
        (e.key === `ArrowRight` && i(n[(t + 1) % n.length].id),
          e.key === `ArrowLeft` && i(n[(t - 1 + n.length) % n.length].id));
      }),
      (t[0] = r),
      (t[1] = n),
      (t[2] = i),
      (t[3] = a))
    : (a = t[3]);
  let o = a,
    s;
  if (t[4] !== r || t[5] !== n || t[6] !== i) {
    let e;
    (t[8] !== r || t[9] !== i
      ? ((e = (e) => {
          let t = e.id === r;
          return (
            <button
              key={e.id}
              type={`button`}
              role={`tab`}
              aria-selected={t}
              tabIndex={t ? 0 : -1}
              onClick={() => i(e.id)}
              className={`-mb-px border-b-2 px-3 py-2 text-sm transition duration-150 ease-(--curva) ${Vo} ${t ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
              children={e.label}
            />
          );
        }),
        (t[8] = r),
        (t[9] = i),
        (t[10] = e))
      : (e = t[10]),
      (s = n.map(e)),
      (t[4] = r),
      (t[5] = n),
      (t[6] = i),
      (t[7] = s));
  } else s = t[7];
  let c;
  return (
    t[11] !== s || t[12] !== o
      ? ((c = (
          <div
            role={`tablist`}
            onKeyDown={o}
            className={`flex gap-1 border-b border-(--border)`}
            children={s}
          />
        )),
        (t[11] = s),
        (t[12] = o),
        (t[13] = c))
      : (c = t[13]),
    c
  );
}
